import React from "react";

import Modal from "../Modal";
import { useModal } from "../../context/ModalContext";
import { Button } from "../Button";

const VerifyResetModal: React.FC = () => {
  const { isVerifyResetOpen, closeVerifyResetModal } = useModal();

  return (
    <Modal
      isOpen={isVerifyResetOpen}
      onClose={closeVerifyResetModal}
      className="h-[200px] w-[484px]"
    >
      <p className="text-center text-sm text-gray-500 mb-4 dark:text-white">
        A link to reset your password has been sent to your email.
      </p>
      <p className="justify-center text-center">
        <Button
          onClick={closeVerifyResetModal}
          type="submit"
          bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
          textColor="text-white"
          borderRadius="rounded-lg"
        >
          Close
        </Button>
      </p>
    </Modal>
  );
};

export default VerifyResetModal;
